import { useJpa } from '@stores';
import { JpaTableInputRowData, JpaTableInputCellData } from './jpaTableInput.types';

export const getTableRows = (formId: number, questionId: number) => {
  const { tableAnswerSet } = useJpa.getState();
  const tableData = tableAnswerSet?.[`f${formId}`]?.[`q${questionId}`] || {};

  const tableRows = Object.keys(tableData).reduce((pageAcc: JpaTableInputRowData[], pageKey: string) => {
    const pageData = tableData[pageKey];

    return pageData ? pageAcc.concat(pageData) : pageAcc;
  }, []);

  return tableRows;
};

export const getCompletedTableRows = (formId: number, questionId: number) => {
  const tableRows = getTableRows(formId, questionId);
  return tableRows.filter((row: JpaTableInputRowData) =>
    row.some(
      (cell: JpaTableInputCellData) =>
        !cell.isDeleted && cell.value !== undefined && cell.value !== null && cell.value !== ''
    )
  );
};
